import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { trackClickEvent } from '../../utils/analytics';

import Media1 from '../../assets/images/singleturbine5A.jpg';
import Media2 from '../../assets/images/singleturbine7.jpg';
import Media3 from '../../assets/images/singleturbine5B.jpg';
import Media4 from '../../assets/images/singleturbine8B.jpg';
import Media5 from '../../assets/images/singleturbine4.jpg';
import Media6 from '../../assets/images/singleturbine8D.jpg';
const slides = [
  {
    image: Media1,
    label: '01 — Pilatus PC-12',
    location: 'XYZ, Alaska',
    
  },
  {
    image: Media2,
    label: '02 — All in Aviation Fleet',
    location: 'Henderson, NV',
    
  },
  {
    image: Media3,
    label: '03 — Citation CJ3 Cabin',
    location: 'XYZ, Alaska',
    
  },
  {
    image: Media4,
    label: '04 — Multiturbine Steps',
    location: 'XYZ, Alaska',
    
  },
  {
    image: Media5,
    label: '05 — Cirrus SR22 Screen',
    location: 'XYZ, Alaksa',
  
  },
  {
    image: Media6,
    label: '05 — Cirrus SR22 Screen',
    location: 'XYZ, Alaksa',
    
  }
];

export default function SingleTurbineSlider() {
  const [current, setCurrent] = useState(0);
  const isMobile = window.innerWidth < 768;

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
    trackClickEvent('GallerySlide', 'Clicked: Next Button');
  };

  return (
    <div className={`relative w-full ${isMobile ? 'h-auto' : 'h-[80vh]'} overflow-hidden ${isMobile ? 'aspect-square' : 'flex'}`}>
      <div className="relative w-full h-full">
        {slides.map((slide, i) => {
          const isCurrent = i === current;
          const isNext = (i === (current + 1) % slides.length);

          return (
            <div
              key={i}
              className={`absolute top-0 transition-all duration-500 ease-in-out h-full ${
                isMobile
                  ? `${isCurrent ? 'left-0 w-full opacity-100 z-30' : 'left-0 w-full opacity-0 z-0'}`
                  : isCurrent
                  ? 'left-0 w-[calc(80%-1px)] z-30 translate-y-0'
                  : isNext
                  ? 'w-[calc(20%-1px)] z-20 translate-y-0'
                  : 'left-0 w-full opacity-0 z-0'
              }`}
              style={
                !isMobile && isNext ? { left: 'calc(80% + 1px)' } : undefined
              }
            >
              <Link
                to={slide.link}
                onClick={() =>
                  trackClickEvent('GallerySlide', `Clicked: ${slide.label}`, slide.link)
                }
                className="block w-full h-full relative cursor-pointer group"
              >
                <img
                  src={slide.image}
                  alt={slide.label}
                  className="w-full h-full object-cover"
                />
                <div className="absolute bottom-4 left-4 bg-black bg-opacity-50 text-white p-2 text-xs md:text-base z-40 group-hover:underline">
                  <div className="font-medium">{slide.label}</div>
                  <div>{slide.location}</div>
                  <div>{slide.coords}</div>
                </div>
              </Link>
            </div>
          );
        })}
      </div>

      <button
        onClick={nextSlide}
        className="absolute right-4 bottom-4 md:top-1/2 transform md:-translate-y-1/2 px-8 py-4 h-20 rounded-full bg-white/10 hover:bg-white/20 text-white font-body font-semibold backdrop-blur-md transition duration-300 border border-white/30 text-lg inline-flex items-center justify-between gap-3 z-50"
      > 
        
        <ArrowRight className="w-6 h-6 stroke-[1.5]" />
      </button>
    </div>
  );
}
